import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiLink2, FiHexagon, FiBookOpen, FiBriefcase, FiCompass, FiGrid, FiLogOut, FiMail, FiMenu, FiX } from 'react-icons/fi';
import { FaRegChartBar } from 'react-icons/fa';
import { HiOutlineDocumentText, HiOutlineAcademicCap } from 'react-icons/hi';
import * as utils from '../../utils/utils';
import styles from './Sidebar.module.css';

const navigationItems = [
	{
		label: 'Dashboard',
		to: '/dashboard',
		exact: true,
		icon: FiGrid,
	},
	{
		label: 'Log Live-Resume',
		to: '/live-resume',
		exact: true,
		icon: HiOutlineDocumentText,
	},
	// Next
	// {
	// 	label: 'Invite',
	// 	to: '/invite',
	// 	exact: true,
	// 	icon: FiMail,
	// },
	// Next {
	// 	label: 'Stream',
	// 	to: '/stream',
	// 	exact: true,
	// 	icon: FiCompass,
	// },
	// {
	// 	label: 'Learn',
	// 	to: '/learn',
	// 	exact: true,
	// 	icon: HiOutlineAcademicCap,
	// },
	// Next {
	// 	label: 'Ask',
	// 	to: '/ask',
	// 	exact: true,
	// 	icon: FiHexagon,
	// },
	// Next {
	// 	label: 'Intros',
	// 	to: '/intros',
	// 	exact: true,
	// 	icon: FiLink2,
	// },
	// {
	// 	label: 'Explore',
	// 	to: '/explore',
	// 	exact: true,
	// 	icon: FiCompass,
	// },
	// {
	// 	label: 'Jobs Center',
	// 	to: '/jobs-center',
	// 	exact: true,
	// 	icon: FiBriefcase,
	// },
	// {
	// 	label: 'My Courses',
	// 	to: '/my-courses',
	// 	exact: true,
	// 	icon: FiBookOpen,
	// },
	// {
	// 	label: 'Competency Matrix',
	// 	to: '/competency-matrix',
	// 	exact: true,
	// 	icon: FaRegChartBar,
	// },
];

export default class Sidebar extends React.Component {
	constructor(props) {
		super(props);

		// State initialization
		this.state = {
			isOpen: false,
			isLoggingOut: false,
		};

		// Method bindings to ensure correct `this` context
		this.closeSidebar = this.closeSidebar.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.onLogoutClick = this.onLogoutClick.bind(this);
	};

	closeSidebar = () => {
		this.setState({ isOpen: false });
	};

	toggleSidebar = () => {
		this.setState({
			isOpen: !this.state.isOpen,
		});
	};

	onLogoutClick = async () => {
		if (this.state.isLoggingOut) {
			return;
		}

		this.setState({ isLoggingOut: true });

		try {
			await utils.sendRequest('/auth/logout', {});
		} catch (error) {
			console.log('sidebar logout error', error);
		}

		utils.removeAuthDetails();
		window.location.href = '/';
	};

	render() {
		const { isOpen, isLoggingOut } = this.state;

		return (
			<>
				{/* Mobile Toggle Button */}
				<button
					type="button"
					className={styles.toggleButton}
					onClick={this.toggleSidebar}
					aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
					aria-expanded={isOpen}
				>
					{isOpen ? <FiX /> : <FiMenu />}
				</button>

				{/* Backdrop Overlay for Mobile */}
				<div
					className={`${styles.backdrop} ${isOpen ? styles.backdropVisible : ''}`}
					onClick={this.closeSidebar}
					aria-hidden={!isOpen}
				/>

				{/* Sidebar Shell */}
				<aside className={`${styles.sidebarShell} ${isOpen ? styles.sidebarOpen : ''}`}>
					<div className={styles.glowTop} />
					<div className={styles.glowBottom} />

					<div className={styles.sidebarContent}>
						{/* Header/Brand Section */}
						<div className={styles.brandBlock}>
							<div className={styles.logoBadge}>HQVibe</div>
							<p className={styles.brandEyebrow}>Career Intelligence Workspace</p>
							<h1 className={styles.brandTitle}>Professional momentum, organized.</h1>
							<p className={styles.brandText}>
								Navigate your dashboard, live-resume workflow, and growth surfaces from one focused control panel.
							</p>
						</div>

						{/* Navigation Items */}
						<nav className={styles.nav} aria-label="Primary">
							{navigationItems.map(({ label, to, exact, icon: Icon }) => (
								<NavLink
									key={to}
									to={to}
									exact={exact}
									className={styles.navLink}
									activeClassName={styles.navLinkActive}
									onClick={this.closeSidebar}
								>
									<span className={styles.iconWrap}>
										<Icon />
									</span>
									<span className={styles.linkText}>{label}</span>
								</NavLink>
							))}

							{/* Action Buttons */}
							<button
								type="button"
								className={`${styles.logoutButton} ${isLoggingOut ? styles.logoutButtonDisabled : ''}`}
								onClick={this.onLogoutClick}
								disabled={isLoggingOut}
							>
								<span className={styles.iconWrap}>
									<FiLogOut />
								</span>
								<span className={styles.linkText}>
									{isLoggingOut ? 'Logging out...' : 'Logout'}
								</span>
							</button>
						</nav>
					</div>
				</aside>
			</>
		);
	};
}